import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import CastIcon from '@mui/icons-material/Cast'
import ListAltIcon from '@mui/icons-material/ListAlt'
import VideocamIcon from '@mui/icons-material/Videocam'
import InputIcon from '@mui/icons-material/Input'
import DnsIcon from '@mui/icons-material/Dns'
import hipladeTemplate from '../../common/template'
import { useDefaultStyles } from '../../common/styles/default'
import ActiveChannelsMonitor from '../components/ActiveChannelsMonitor'
import StreamingList from '../components/StreamingList'
import CameraProvision from '../components/CameraProvision'
import GcpInputsList from '../components/GcpInputsList'
import GcpChannelsList from '../components/GcpChannelsList'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function TabPanel({ children, value, index }: TabPanelProps) {
  return (
    <Box role="tabpanel" hidden={value !== index} pt={3}>
      {value === index && children}
    </Box>
  )
}

function StreamingManagementPage() {
  const classes = useDefaultStyles()
  const [tab, setTab] = useState(0)

  return (
    <Box className={classes.container}>
      <Box mb={3}>
        <Typography variant="h5" fontWeight={600}>
          Gestão de Streamings
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Monitore os canais ativos, gerencie o histórico de transmissões e a provisão de recursos.
        </Typography>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)} aria-label="abas de gestão de streaming">
          <Tab icon={<CastIcon />} iconPosition="start" label="Monitor ao vivo" />
          <Tab icon={<ListAltIcon />} iconPosition="start" label="Histórico" />
          <Tab icon={<VideocamIcon />} iconPosition="start" label="Provisão de Recursos" />
          <Tab icon={<InputIcon />} iconPosition="start" label="Inputs GCP" />
          <Tab icon={<DnsIcon />} iconPosition="start" label="Channels GCP" />
        </Tabs>
      </Box>

      <TabPanel value={tab} index={0}>
        <ActiveChannelsMonitor />
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <StreamingList />
      </TabPanel>
      <TabPanel value={tab} index={2}>
        <CameraProvision />
      </TabPanel>
      <TabPanel value={tab} index={3}>
        <GcpInputsList />
      </TabPanel>
      <TabPanel value={tab} index={4}>
        <GcpChannelsList />
      </TabPanel>
    </Box>
  )
}

export default hipladeTemplate(StreamingManagementPage)
